import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { ActionBar, Content, DashList, DataListWrap, Img, MoreTags, Td, TitleLeft } from './NoteDetails.styled';
import moment from 'moment';
import { useStore } from '@store/appStore';
import StudentThumbnail from '@components/StudentThumbnail';
import More_Icon from "@assets/svg/more.svg";
import Pagination from '../Pagination';
import SortArrow from '../SortArrow';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import EmptyBox from '../EmptyBox';
import { Tag, Tags } from '../RegistrationDetails/RegistrationDetails.styled';
import Tooltip from '@components/Tooltips/Tooltip';
import { normalizeName } from '@utils/textTools';
import { GenerateExcelFile } from '../excel';

interface IProps { getNotes: () => void, loading: boolean, handleClick: (username, id, displayname, type, sick?) => void }

export const NoteDetails = forwardRef((props: IProps, ref) => {
  useImperativeHandle(ref, () => ({
    exportExcel() {
      Excel()
    },
  }));
  const { client, handleNote, filterDate, schoolViewTags, schoolViewNotes, setSchoolViewNotes, schoolViewFilter, setSchoolViewFilter, page, setPage, systemSettings } = useStore();
  const [sort, setSort] = useState({ type: 0, direction: false })
  const tagsCount = useRef(0)
  const pageSize = 13;
  const i18n = useI18n();
  let freeTextNotes = systemSettings?.find(s => s.APP_Setting_ID === 42)
  let studentCallName = systemSettings?.find(s => s.APP_Setting_ID === 48).value;

  useEffect(() => {
    getNotes()
  }, [filterDate])

  const getNotes = async () => {
    await props.getNotes()
  }

  const getFilteredNotes = () => {
    let registrationsTemp = JSON.parse(JSON.stringify(schoolViewNotes))
    registrationsTemp = registrationsTemp?.filter(s => s.displayname?.toLowerCase().includes(schoolViewFilter.search4?.toLowerCase())).filter(s => {
      if (schoolViewFilter.tags.length === 0) return true
      else {
        let tagFound = false
        let tags = s.tag_ids?.split(',')                
        for (let i = 0; i < tags?.length; i++) {
          const t = tags[i];
          if (schoolViewFilter.tags.some(n => n == t)) tagFound = true
        }
        return tagFound
      }
    })?.filter(s => {
      if (schoolViewFilter.fromDate4 === null) return true
      let fromDate = moment(schoolViewFilter.fromDate4)
      let toDate = moment(schoolViewFilter.toDate4)
      let date = moment(s.create_timestamp)
      if (date.isBetween(fromDate, toDate, "day", "[]")) return true
      else return false
    })
    return registrationsTemp
  }

  const ConvertTags = (list: any, index: any, extra?:boolean) => {
    if (list === null || list.length < 0) return [];

    let ids = list.split(',');
    let ttags = [];
    
    for (let i = 0; i < ids.length; i++) {
      let tempTag = schoolViewTags.find((t) => t.tag_id == ids[i]);
      if (tempTag) {
        ttags.push(tempTag);
      }
      else if (ids[i] == 99){
        ttags.push({ tag_id: 99, name: "Late", html_color: "FED425" })
      }
    }

    let tempTags = []  
    let tempExtra = []
    ttags.map((t, i) => {
        if(i > 2){
          tempExtra.push(<Tag marginBot={true} key={index + "_tag_" + i} bg={t.html_color} colors={t.html_color === "FED425"}>{i18n.t("tag-" + t.name)}</Tag>)
        } else {
          tempTags.push(<Tag key={index + "_tag_" + i} bg={t.html_color} colors={t.html_color === "FED425"}>{i18n.t("tag-" + t.name)}</Tag>)
        }
      }
    )
    
    if(extra){
      return tempExtra
    } else {
      tagsCount.current = ttags.length
      return tempTags
    }
  };

  function handleSort(type) {
    let direction = false;
    if (type === sort.type) direction = !sort.direction
    setSort({ type: type, direction: direction })
  }

  function getSortedNotes() {
    let noteTemp = getFilteredNotes()
    noteTemp = noteTemp?.sort((a, b) => {
      let dir = sort.direction ? -1 : 1
      switch (sort.type) {
        case 0:
          if (a.displayname > b.displayname) return 1 * dir
          else if (a.displayname < b.displayname) return -1 * dir
          else return 0
          break;
        case 1:
          if (a.tag_ids > b.tag_ids) return 1 * dir
          else if (a.tag_ids < b.tag_ids) return -1 * dir
          else return 0
          break;
        case 2:
          let adate = moment(a.create_timestamp)
          let bdate = moment(b.create_timestamp)
          if (adate.isAfter(bdate)) return 1 * dir
          else if (adate.isBefore(bdate)) return -1 * dir
          else return 0
          break;
        case 3:
          if (a.author_displayname > b.author_displayname) return 1 * dir
          else if (a.author_displayname < b.author_displayname) return -1 * dir
          else return 0
          break;
      }
    })
    return noteTemp
  }

  const getTextCount = () => {
    let count = getFilteredNotes()?.length
    let totalCount = schoolViewNotes?.length
    if (totalCount === count && count > 0) {
      return `${i18n.t('showing')} ${i18n.t('all').toLowerCase()} ${totalCount}`
    }
    else {
      if (count > 0) {
        return `${i18n.t('showing')} ${count} ${i18n.t('of')} ${totalCount}`
      }
      else
        return ""
    }
  }

  const ConvertTagsText = (list: any) => {
    if (list === null || list.length < 0) return [];

    let ids = list.split(',');
    let ttags = [];
    for (let i = 0; i < ids.length; i++) {
      let tempTag = schoolViewTags.find((t) => t.tag_id == ids[i]);
      if (tempTag) {
        ttags.push(tempTag);
      }
      else if (ids[i] == 99) ttags.push({ tag_id: 99, name: "Late", html_color: "FED425" })
    }
    let string = ttags.map((t, i) => i18n.t("tag-" + t.name)).join(", ")
    return string.length === 0 ? " " : string;
  };

  const Excel = () => {
    let data = getSortedNotes().map(r => {
      let object = {}

      object[i18n.t("header-name")] = r.displayname;
      object[i18n.t("date")] = moment(r.create_timestamp).format('DD-MM-YYYY  HH:mm');
      object[i18n.t("author")] = r.author_displayname;
      object[i18n.t("header-tags")] = ConvertTagsText(r.tag_ids);
      if (freeTextNotes.value.toLowerCase() !== "none") {
        object[i18n.t("header-note")] = r.text;
      }
      return object;
    });

    let headers = [
      i18n.t("header-name"),
      i18n.t("date"),
      i18n.t("author"),
      i18n.t("header-tags"),      
    ];
    if (freeTextNotes.value.toLowerCase() !== "none") {
      headers.push(i18n.t("header-note"));
    }

    GenerateExcelFile(i18n.t("menu-note") + "_" + moment().format('DD-MM-YYYY-HHmm'), headers, data, i18n.t("menu-note") + "_" + moment().format('DD-MM-YYYY-HHmm'));
  }

  return (<>
    <Content>
      <TitleLeft>
        <span>{i18n.t("notes")}</span>
        <span>{getTextCount()}</span>
      </TitleLeft>

      {props.loading ? <RainbowLoader /> : getSortedNotes()?.length > 0 ? <><DataListWrap>
        <DashList>
          <tbody>
            <tr>
              <td className={"imgWidth"}></td>
              <Td className={"width15"} onClick={() => handleSort(0)}>{i18n.t("header-name")} <SortArrow sortActive={sort.type === 0} asc={sort.type === 0 && sort.direction === false} /></Td>
              <Td className={"width5"} onClick={() => handleSort(2)}>{i18n.t("header-created")} <SortArrow sortActive={sort.type === 2} asc={sort.type === 2 && sort.direction === false} /></Td>
              <Td className={"width15"} onClick={() => handleSort(3)}>{i18n.t("author")} <SortArrow sortActive={sort.type === 3} asc={sort.type === 3 && sort.direction === false} /></Td>
              <Td className={"width15"}>{i18n.t("header-tags")} </Td>
              {freeTextNotes.value.toLowerCase() !== "none" ? <Td>{i18n.t("header-note")}</Td> : null}
              {/* <td></td> */}
            </tr>
            {schoolViewNotes ? getSortedNotes().slice((page * pageSize - pageSize), pageSize * page).map((n, index) => <tr key={"note_" + index}>
              <td className={"imgWidth"}><Img><StudentThumbnail font={"0.9em"} name={n?.displayname}  src={n.username} /></Img></td>
              <td className={"clickable width15"} onClick={() => props.handleClick(n.username, n.student_id, n.displayname, "STUDENT")}><Tooltip placement='top-start' content={i18n.t("show-details-" + studentCallName)}>{n.displayname}</Tooltip></td>
              <td className={"width5"}><span>{moment(n.create_timestamp).format('DD-MM-YYYY  HH:mm')}</span></td>
              <td className={"width15"}>{n.author_displayname}</td>
              <td className={"width15"}><Tags>{ConvertTags(n.tag_ids, index)} {tagsCount.current > 3?<><Tooltip offsetY={-5} element={ConvertTags(n.tag_ids, index, true)}><MoreTags><More_Icon /></MoreTags></Tooltip></>:<></>} </Tags></td>
              {freeTextNotes.value.toLowerCase() !== "none" ? <td style={{wordBreak:"break-all"}}>{n.text}</td> : null}
              {/* <td>
                <ActionBar>
                  <Note_Icon onClick={() => handleNote(n.sis_id, n.displayname)} />
                </ActionBar>
              </td> */}
            </tr>) : null}
          </tbody>
        </DashList>
      </DataListWrap>

        <Pagination count={getSortedNotes()?.length} pageSize={pageSize} currentPage={page} maxPage={Math.ceil(getSortedNotes()?.length / pageSize)} setPage={setPage} /></> : <EmptyBox Graphic='documents' marvin={true} text={i18n.t("no-filter-data")} />}

    </Content>
  </>);
});

export default NoteDetails;
